import React, { FC, useState } from "react";
import type { AssessmentDto } from "@green0meter/api-client";

import QualitativeAssessmentTable from "./components/QualitativeAssessmentTable";
import AssessmentEditor from "./components/AssessmentEditor";


const QualitativeAssessment: FC = () => {
  const [selectedAssessment, setSelectedAssessment] = useState<AssessmentDto | null>(
    null,
  );
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  const handleAssessmentEdit = (assessment: AssessmentDto): void => {
    setSelectedAssessment(assessment);
    setIsEditorOpen(true);
  };

  const handleEditorClose = (): void => {
    setIsEditorOpen(false);
    setSelectedAssessment(null);
  };

  const handleAddAssessment = (): void => {
    setSelectedAssessment(null);
    setIsEditorOpen(true);
  };

  return (
    <>
      <QualitativeAssessmentTable
        onAssessmentEdit={handleAssessmentEdit}
        onAddAssessment={handleAddAssessment}
      />

      <AssessmentEditor
        open={isEditorOpen}
        onClose={handleEditorClose}
        assessment={selectedAssessment}
      />
    </>
  );
};

export default QualitativeAssessment;
